let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5Q8Jh")).then(() => parcelRequire('deSfB'));